import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { ValueFactoryType } from '../enums/value-factory-type';

@HateoasResource('scim-mapping-configs', { routeName: 'integrationsResourceRoute' })
export class ScimMappingConfig extends Resource {
    id;
    scimIntegrationId;
    name;
    mappings: Array<ValueMapping>;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    deletedBy: string;
    deleted: string;
    resourceState: string;
    selected: boolean;
}

export class ValueMapping {
    constructor(targetProperty: string, valueFactory: ValueFactory) {
        this.targetProperty = targetProperty;
        this.valueFactory = valueFactory;
    }
    targetProperty: string;
    valueFactory: ValueFactory;
}

export abstract class ValueFactory {}

export class DirectValueFactory implements ValueFactory {

    constructor(propertyName: string) {
        this.propertyName = propertyName;
    }
    propertyName: string;
    type = ValueFactoryType.DIRECT;
}

export class StaticValueFactory implements ValueFactory {

    constructor(valueType: ValueType, staticValue: string) {
        this.valueType = valueType;
        this.staticValue = staticValue;
    }

    type: ValueFactoryType.STATIC;
    valueType: ValueType;
    staticValue: string;
}

export enum ValueType {
    'BOOLEAN' = 'BOOLEAN',
    'INT' = 'INT',
    'DOUBLE' = 'DOUBLE',
    'STRING' = 'STRING',
    'LIST' = 'LIST',
    'MAP' = 'MAP',
    'INSTANT' = 'INSTANT',
    'UUID' = 'UUID'
}

export class ScimMappingConfigUpdate {
    name:string ;
    mappings: Array<ValueMapping>;

    constructor(name: string, mappings: Array<ValueMapping>) {
        this.name = name;
        this.mappings = mappings;
    }
}